import React from 'react';

export function FeatureCard({ icon, description }) {
  return (
    <div className="tw-flex tw-flex-col tw-self-stretch tw-rounded-xl" style={{maxWidth: "415px", background: '#E6EBE9'}}>
      <div className="tw-flex tw-gap-6 tw-p-10 tw-bg-gray-200">
        <img
          loading="lazy"
          src={icon}
          alt=""
          className="tw-object-contain tw-shrink-0 tw-self-start tw-bg-black tw-rounded-full"
          style={{width: "32px", height: "32px"}}
        />
        <div className="tw-flex-auto tw-text-2xl tw-font-semibold tw-leading-7 tw-text-black">
          {description}
        </div>
      </div>
    </div>
  );
}
